function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-9 -9)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M22.8 12.6c-.48.24-.96.32-1.52.4.56-.32.96-.8 1.12-1.44-.48.32-1.04.48-1.68.64-.48-.48-1.2-.8-1.92-.8-1.36 0-2.56 1.2-2.56 2.64 0 .24 0 .4.08.56-2.16-.08-4.16-1.12-5.44-2.72-.24.4-.32.8-.32 1.36 0 .88.48 1.68 1.2 2.16-.4 0-.8-.16-1.2-.32 0 1.28.88 2.32 2.08 2.56-.24.08-.48.08-.72.08-.16 0-.32 0-.48-.08a2.592 2.592 0 002.48 1.84c-.88.72-2 1.12-3.28 1.12H10c1.2.72 2.56 1.2 4 1.2 4.8 0 7.44-4 7.44-7.44v-.32c.56-.4 1.04-.88 1.36-1.44z"
}));

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkgLTkpIj4KICAgICAgICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgc3Ryb2tlPSIjMDAwIi8+CiAgICAgICAgPHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMjIuOCAxMi42Yy0uNDguMjQtLjk2LjMyLTEuNTIuNC41Ni0uMzIuOTYtLjggMS4xMi0xLjQ0LS40OC4zMi0xLjA0LjQ4LTEuNjguNjQtLjQ4LS40OC0xLjItLjgtMS45Mi0uOC0xLjM2IDAtMi41NiAxLjItMi41NiAyLjY0IDAgLjI0IDAgLjQuMDguNTYtMi4xNi0uMDgtNC4xNi0xLjEyLTUuNDQtMi43Mi0uMjQuNC0uMzIuOC0uMzIgMS4zNiAwIC44OC40OCAxLjY4IDEuMiAyLjE2LS40IDAtLjgtLjE2LTEuMi0uMzIgMCAxLjI4Ljg4IDIuMzIgMi4wOCAyLjU2LS4yNC4wOC0uNDguMDgtLjcyLjA4LS4xNiAwLS4zMiAwLS40OC0uMDhhMi41OTIgMi41OTIgMCAwIDAgMi40OCAxLjg0Yy0uODguNzItMiAxLjEyLTMuMjggMS4xMkgxMGMxLjIuNzIgMi41NiAxLjIgNCAxLjIgNC44IDAgNy40NC00IDcuNDQtNy40NHYtLjMyYy41Ni0uNCAxLjA0LS44OCAxLjM2LTEuNDR6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgTwitter as ReactComponent };